import Users from "./Users";

class AllUsersAdmins extends Users {

    loadTableUsers = () => {
        this.props.loadGet("/users/admin", this.loadContent, this.loadError)
    }
}

export default AllUsersAdmins;